import { Box, Button, Container, Grid, Stack, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import Iconify from "src/components/iconify/Iconify";
import MarketplaceStats from "src/components/marketplace/MarketplaceStats";
import PurchasesTable from "src/components/purchases-table/PurchasesTable";
import TopPurchaseProductsTable from "src/components/purchases-table/TopPurchaseProductsTable";
import TopPurchaseUsersTable from "src/components/purchases-table/TopPurchaseUsersTable";
import { get } from "src/utils/networkUtils";

function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}
function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
			{value === index && <Box sx={{ p: 1, paddingTop: 3 }}>{children}</Box>}
		</div>
	);
}
export default function MarketplaceDashboardPage() {
	const navigate = useNavigate();
	const [purchases, setPurchases] = useState(null);
	const [valueInfo, setValueInfo] = useState(0);
	const [purchasesStats, setPurchasesStats] = useState(null);
	const [topUsersPurchases, setTopUsersPurchases] = useState(null);
	const [topProducts, setTopProducts] = useState(null);

	const handleChangeInfoTabs = (event, newValue) => {
		setValueInfo(newValue);
	};
	useEffect(() => {
		get(`/admin/marketplace/store-items/purchases`).then((response) => {
			setPurchases(response.purchases);
			setTopUsersPurchases(response.topUsers);
			setTopProducts(response.topProducts);
		});
		get(`/admin/marketplace/purchases/stats`).then((response) => {
			setPurchasesStats(response.stats);
		});
	}, []);
	return (
		<>
			<Helmet>
				<title> Store </title>
			</Helmet>

			<Container maxWidth="xl">
				<Stack direction="row" alignItems="center" justifyContent="space-between">
					<Typography variant="h4" sx={{ mb: 5 }}>
						Store
					</Typography>

					<Grid container spacing={2} justifyContent={"flex-end"} sx={{ mb: 2 }}>
						<Grid item xs={8} md={2} lg={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
							<Button
								onClick={() => navigate("/dashboard/marketplace-store-items?tenant=football")}
								variant="contained"
								sx={{ mr: 1 }}
								startIcon={<Iconify icon={"eva:settings-2-outline"} width={24} height={24} />}
							>
								Coins
							</Button>
						</Grid>
						{/* <Grid
              item
              xs={8}
              md={2}
              lg={2}
              sx={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              <Button
                onClick={() => navigate('/dashboard/megaspins')}
                variant='contained'
                startIcon={
                  <Iconify
                    icon={'eva:settings-2-outline'}
                    width={24}
                    height={24}
                  />
                }
              >
                Mega Spin
              </Button>
            </Grid> */}
					</Grid>
				</Stack>
				{purchasesStats !== null && <MarketplaceStats stats={purchasesStats} />}
				<Box sx={{ width: "100%" }}>
					<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
						<Tabs value={valueInfo} onChange={handleChangeInfoTabs} aria-label="basic tabs example">
							<Tab label="Purchases" {...a11yProps(0)} />
							<Tab label="Top Purchasers" {...a11yProps(1)} />
							<Tab label="Top Products" {...a11yProps(2)} />
						</Tabs>
					</Box>
					<TabPanel value={valueInfo} index={0}>
						{purchases !== null && <PurchasesTable purchases={purchases} />}
					</TabPanel>
					<TabPanel value={valueInfo} index={1}>
						<TopPurchaseUsersTable users={topUsersPurchases ?? []} />
					</TabPanel>
					<TabPanel value={valueInfo} index={2}>
						<TopPurchaseProductsTable users={topProducts ?? []} />
					</TabPanel>
				</Box>
			</Container>
		</>
	);
}
